const aaa = [
	{
		path: "guahaoAdd",
		component: () => import("@/views/yingxiao/guahaoAdd.vue"),
		meta:{title:'挂号'},
	},
]
export default aaa;